// import React, { useState, useEffect } from "react";
// import classroom from "../../Assets/Images/Home/classroom.jpg";
// import { FULL_API_BASE_URL } from "../../Config/Config";

// const Home = (dataClient) => {
//   const user_name = dataClient?.dataClient?.client_schema_name[6][0].user_name;
//   const clientBranchId =
//     dataClient.dataClient?.client_schema_name[6][0].client_branch_id;
//   const clientId = dataClient?.dataClient?.client_schema_name[6][0].client_id;
//   const userId = dataClient?.dataClient?.client_schema_name[6][0].user_id;
//   console.log("home", clientId, userId);
//   const [data, setData] = useState([]);
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/client_landing_page_info_web/?client_id=${clientId}&user_id=${userId}`
//         );
//         const data = await response.json();
//         setData(data);
//       } catch (error) {
//         console.error("Error fetching courses:", error);
//       }
//     };
//     fetchData();
//   }, []);
//   return (
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "100%",
//       }}
//     >
//       <img src={classroom} alt="" style={{ width: "100%", height: "100%" }} />
//     </div>
//   );
// };

// export default Home;

// import React, { useState, useEffect } from "react";
// import classroom from "../../Assets/Images/Home/classroom.jpg";
// import errorImage from "../../Assets/dsc_bpl.png"; // Import your alternative image
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import SiteUnderMaintanance from "../../Assets/Images/CommanImages/OIP (2).jpg";
// const Home = (dataClient) => {
//   const user_name =
//     dataClient?.dataClient?.client_schema_name?.[6]?.[0]?.user_name;
//   const clientBranchId =
//     dataClient?.dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const clientId =
//     dataClient?.dataClient?.client_schema_name?.[6]?.[0]?.client_id;
//   const userId = dataClient?.dataClient?.client_schema_name?.[6]?.[0]?.user_id;
//   // console.log("home", clientId, userId);
//   const [data, setData] = useState([]);

//   useEffect(() => {
//     if (clientId && userId) {
//       const fetchData = async () => {
//         try {
//           const response = await fetch(
//             `${FULL_API_BASE_URL}/client_landing_page_info_web/?client_id=${clientId}&user_id=${userId}`
//           );
//           const data = await response.json();
//           setData(data);
//         } catch (error) {
//           console.error("Error fetching courses:", error);
//         }
//       };
//       fetchData();
//     }
//   }, [clientId, userId]);

//   // console.log("home", clientId, userId);

//   return (
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "100%",
//       }}
//     >
//       {clientId && userId ? (
//         <img
//           src={classroom}
//           alt="Classroom"
//           style={{ width: "100%", height: "100%" }}
//         />
//       ) : (
//         <>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "center",
//               alignItems: "center",
//               height: "80vh",
//               fontFamily: "Arial, sans-serif",
//               backgroundColor: "white",
//             }}
//           >
//             <img
//               src={SiteUnderMaintanance}
//               alt="Error"
//               style={{
//                 width: "30vw",
//                 height: "30vh",
//                 backgroundColor: "#2F2E40",
//                 borderRadius: "10px",
//                 color: "white",
//               }}
//             />
//             <h1
//               style={{
//                 color: "cornflowerblue",
//                 textShadow: "1px 1px 1px rgba(0, 0, 0, 0.5)",
//                 marginTop: "20px",
//               }}
//             >
//               Site Under Maintenance
//             </h1>
//             <p
//               style={{
//                 color: "cornflowerblue",
//                 textShadow: "1px 1px 1px rgba(0, 0, 0, 0.5)",
//                 marginTop: "10px",
//               }}
//             >
//               We are currently performing scheduled maintenance.
//             </p>
//             <p
//               style={{
//                 color: "cornflowerblue",
//                 textShadow: "1px 1px 1px rgba(0, 0, 0, 0.5)",
//                 marginTop: "5px",
//               }}
//             >
//               We should be back online shortly.
//             </p>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default Home;

import React, { useState, useEffect } from "react";
import classroom from "../../Assets/Images/Home/classroom.jpg";
import errorImage from "../../Assets/dsc_bpl.png"; // Import your alternative image
import { FULL_API_BASE_URL } from "../../Config/Config";
import SiteUnderMaintanance from "../../Assets/Images/CommanImages/OIP (2).jpg";
import EndPoints from "../../../src/Api/EndPoints";

const Home = (dataClient) => {
  const user_name =
    dataClient?.dataClient?.client_schema_name?.[6]?.[0]?.user_name;
  const clientBranchId =
    dataClient?.dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
  const clientId =
    dataClient?.dataClient?.client_schema_name?.[6]?.[0]?.client_id;
  const userId = dataClient?.dataClient?.client_schema_name?.[6]?.[0]?.user_id;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const reduxDataReady = !!dataClient?.dataClient?.client_schema_name;

  useEffect(() => {
    if (!reduxDataReady) return;

    if (clientId && userId) {
      const fetchData = async () => {
        setLoading(true);
        setError(false);
        try {
          // const token = localStorage.getItem("other");
          const response = await fetch(
            `${EndPoints.CLIENT_LANDING_PAGE_INFO_V2}?client_id=${clientId}&user_id=${userId}&client_branch_id=${clientBranchId}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${token}`,
              },
            }
          );

          if (!response.ok) throw new Error("API error");

          const result = await response.json();
          setData(result);
        } catch (err) {
          console.error("Error fetching courses:", err);
          setError(true);
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    } else {
      // Redux is ready but clientId/userId genuinely missing
      setLoading(false);
      setError(true);
    }
  }, [clientId, userId, reduxDataReady]);
  useEffect(() => {
    if (loading) {
      document.body.style.cursor = "wait";
    } else {
      document.body.style.cursor = "default";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.cursor = "default";
    };
  }, [loading]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      {loading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "80vh",
            justifyContent: "center",
          }}
        >
          {/* <div className="loader"></div> */}
          <p style={{ color: "cornflowerblue", marginTop: "16px" }}>
            Loading...
          </p>
        </div>
      ) : error ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
            fontFamily: "Arial, sans-serif",
            backgroundColor: "white",
          }}
        >
          <img
            src={SiteUnderMaintanance}
            alt="Error"
            style={{
              width: "30vw",
              height: "30vh",
              backgroundColor: "#2F2E40",
              borderRadius: "10px",
            }}
          />
          <h1
            style={{
              color: "cornflowerblue",
              textShadow: "1px 1px 1px rgba(0,0,0,0.5)",
              marginTop: "20px",
            }}
          >
            Site Under Maintenance
          </h1>
          <p style={{ color: "cornflowerblue", marginTop: "10px" }}>
            We are currently performing scheduled maintenance.
          </p>
          <p style={{ color: "cornflowerblue", marginTop: "5px" }}>
            We should be back online shortly.
          </p>
        </div>
      ) : (
        <img
          src={classroom}
          alt="Classroom"
          style={{ width: "100%", height: "100%" }}
        />
      )}
    </div>
  );
};

export default Home;
